import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-intro-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './notification-intro-dialog.component.html',
  styleUrl: './notification-intro-dialog.component.scss',
})
export class NotificationIntroDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<NotificationIntroDialogComponent>
  ) {}

  onDismiss(): void {
    this.dialogRef.close(true);
  }
}
